export default {
    baseStyle: {
        indicator: {
            width: '21px',
            height: '21px',
            backgroundColor: 'white',
            border: '1px solid !important',
            borderColor: 'gray.600 !important'
        },
        title: {
            color: 'gray.650',
            fontSize: '9px',
            fontWeight: '300',
            lineHeight: 'normal',
            letterSpacing: '0.045px'
        },
        description: {
            color: 'black',
            fontSize: '10px',
            fontWeight: '600',
            lineHeight: 'normal',
            letterSpacing: '0.05px'
        }
    },
    variants: {
        pdp: {
            title: {
                fontSize: '11px',
                color: 'gray.650',
                letterSpacing: '0.055px'
            },
            description: {
                fontSize: '11px',
                letterSpacing: '0.055px',
                marginTop: '2px'
            }
        }
    }
}
